// @generated by protoc-gen-es v2.9.0 with parameter "target=ts,import_extension=.js"
// @generated from file inventory/v1/item_group_events.proto (package inventory.v1, edition 2023)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ItemGroup } from "./item_group_pb.js";
import { file_inventory_v1_item_group } from "./item_group_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/item_group_events.proto.
 */
export const file_inventory_v1_item_group_events: GenFile = /*@__PURE__*/
  fileDesc("CiRpbnZlbnRvcnkvdjEvaXRlbV9ncm91cF9ldmVudHMucHJvdG8SDGludmVudG9yeS52MSLBAQoOSXRlbUdyb3VwRXZlbnQSNgoHY3JlYXRlZBgBIAEoCzIjLmludmVudG9yeS52MS5JdGVtR3JvdXBDcmVhdGVkRXZlbnRIABI2Cgd1cGRhdGVkGAIgASgLMiMuaW52ZW50b3J5LnYxLkl0ZW1Hcm91cFVwZGF0ZWRFdmVudEgAEjYKB2RlbGV0ZWQYAyABKAsyIy5pbnZlbnRvcnkudjEuSXRlbUdyb3VwRGVsZXRlZEV2ZW50SABCBwoFZXZlbnQiRAoVSXRlbUdyb3VwQ3JlYXRlZEV2ZW50EisKCml0ZW1fZ3JvdXAYASABKAsyFy5pbnZlbnRvcnkudjEuSXRlbUdyb3VwIoIBChVJdGVtR3JvdXBVcGRhdGVkRXZlbnQSNAoTcHJldmlvdXNfaXRlbV9ncm91cBgBIAEoCzIXLmludmVudG9yeS52MS5JdGVtR3JvdXASMwoSdXBkYXRlZF9pdGVtX2dyb3VwGAIgASgLMhcuaW52ZW50b3J5LnYxLkl0ZW1Hcm91cCJEChVJdGVtR3JvdXBEZWxldGVkRXZlbnQSKwoKaXRlbV9ncm91cBgBIAEoCzIXLmludmVudG9yeS52MS5JdGVtR3JvdXBCN1o1cGFja2FnZXMvYmFja2VuZC1tb2R1bGUtaW52ZW50b3J5L2FwaS92MTtpbnZlbnRvcnlfdjFiCGVkaXRpb25zcOgH", [file_inventory_v1_item_group]);

/**
 * @generated from message inventory.v1.ItemGroupEvent
 */
export type ItemGroupEvent = Message<"inventory.v1.ItemGroupEvent"> & {
  /**
   * @generated from oneof inventory.v1.ItemGroupEvent.event
   */
  event: {
    /**
     * @generated from field: inventory.v1.ItemGroupCreatedEvent created = 1;
     */
    value: ItemGroupCreatedEvent;
    case: "created";
  } | {
    /**
     * @generated from field: inventory.v1.ItemGroupUpdatedEvent updated = 2;
     */
    value: ItemGroupUpdatedEvent;
    case: "updated";
  } | {
    /**
     * @generated from field: inventory.v1.ItemGroupDeletedEvent deleted = 3;
     */
    value: ItemGroupDeletedEvent;
    case: "deleted";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message inventory.v1.ItemGroupEvent.
 * Use `create(ItemGroupEventSchema)` to create a new message.
 */
export const ItemGroupEventSchema: GenMessage<ItemGroupEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group_events, 0);

/**
 * @generated from message inventory.v1.ItemGroupCreatedEvent
 */
export type ItemGroupCreatedEvent = Message<"inventory.v1.ItemGroupCreatedEvent"> & {
  /**
   * @generated from field: inventory.v1.ItemGroup item_group = 1;
   */
  itemGroup?: ItemGroup;
};

/**
 * Describes the message inventory.v1.ItemGroupCreatedEvent.
 * Use `create(ItemGroupCreatedEventSchema)` to create a new message.
 */
export const ItemGroupCreatedEventSchema: GenMessage<ItemGroupCreatedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group_events, 1);

/**
 * @generated from message inventory.v1.ItemGroupUpdatedEvent
 */
export type ItemGroupUpdatedEvent = Message<"inventory.v1.ItemGroupUpdatedEvent"> & {
  /**
   * @generated from field: inventory.v1.ItemGroup previous_item_group = 1;
   */
  previousItemGroup?: ItemGroup;

  /**
   * @generated from field: inventory.v1.ItemGroup updated_item_group = 2;
   */
  updatedItemGroup?: ItemGroup;
};

/**
 * Describes the message inventory.v1.ItemGroupUpdatedEvent.
 * Use `create(ItemGroupUpdatedEventSchema)` to create a new message.
 */
export const ItemGroupUpdatedEventSchema: GenMessage<ItemGroupUpdatedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group_events, 2);

/**
 * @generated from message inventory.v1.ItemGroupDeletedEvent
 */
export type ItemGroupDeletedEvent = Message<"inventory.v1.ItemGroupDeletedEvent"> & {
  /**
   * @generated from field: inventory.v1.ItemGroup item_group = 1;
   */
  itemGroup?: ItemGroup;
};

/**
 * Describes the message inventory.v1.ItemGroupDeletedEvent.
 * Use `create(ItemGroupDeletedEventSchema)` to create a new message.
 */
export const ItemGroupDeletedEventSchema: GenMessage<ItemGroupDeletedEvent> = /*@__PURE__*/
  messageDesc(file_inventory_v1_item_group_events, 3);

